import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
  Dropdown,
} from "react-bootstrap";
import { Bar, Pie } from "react-chartjs-2";
import { useHistory } from "react-router-dom";
import CustomNavbar from "../../components/CustomNavbar";
import SidebarConfig from "../../components/SidebarDashboard";

import onBoardingPic from "../../images/OnBoardingOffBoarding/onboarding3.png";
import onBoardingteachingPic from "../../images/OnBoardingOffBoarding/teachings.png";
import { getDashboardSelecResp } from "../../redux/seleccionContratacion/dashboardSeleccionContratacion/actions";
import { getDashboardSelecRespContrataciones } from "../../redux/seleccionContratacion/dashboardSeleccionContratacion/contrataciones/actions";
import { getDashboarSelecVacantes } from "../../redux/seleccionContratacion/dashboardSeleccionContratacion/vacantes/actions";
import "../../css/onboarding.css";
import moment from "moment";
import { ContactSupport } from "@material-ui/icons";

const DashboardSeleccionContratacion = (props) => {
  const [show, setShow] = useState(false);
  const [validated, setValidated] = useState(false);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [filter, setFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [showFormModal, setShowFormModal] = useState(false);
  const [filtroBusquedaS, setFiltroBusquedaS] = useState("");

  const [dat, setDat] = useState(
    `${moment().format("YYYY")}-${moment().format("MM")}-01`
  );
  const dispatch = useDispatch();
  const { dashboardSelectData, loaderDashboard } = useSelector(
    (store) => store.dashBoardSelect
  );
  const { loaderDashboardContrataciones, dashboardSelectDataContrataciones } =
    useSelector((store) => store.dashBoardSelectContrataciones);

  const { loaderDashboardVacantes, dashboardSelectDataVacantes } = useSelector(
    (store) => store.dashBoardSelectVacantes
  );

  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "filter_puesto",
    desc: "Código de puesto",
  });

  const userRoles = useSelector((store) => store.auth.userRoles);
  const history = useHistory();

  useEffect(() => {
    if (isNaN(props.match.params.tipoWorkflow)) {
      //let valor = props.match.params.tipoWorkflow.toLowerCase();
      //if (valor) {
      // history.push("/seleccion-contratacion/dashboardSeleccionContratacion");
      history.push(
        "/seleccion-contratacion/indicadores/indicador-selección-y-contratacion"
      );

      dispatch(
        getDashboardSelecRespContrataciones({
          fecha: dat,
          tipo_workflow: parseInt(1),
        })
      );
      dispatch(
        getDashboardSelecResp({ fecha: dat, tipo_workflow: parseInt(1) })
      );
      dispatch(getDashboarSelecVacantes({ fechat: dat }));
      //  }
    } else {
      history.goBack();
    }
  }, [dispatch, dat, props.match.params.tipoWorkflow]);

  {
    /* Filtro */
  }

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getDaashboard(oOffset, limit, oSearch);
  };

  const onAdd = () => {
    setShowFormModal(true);
    setEdit(false);
    setValidated(false);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }
    setDat(
      `${moment(e.target.fecha_min.value).format("YYYY")}-${moment(
        e.target.fecha_min.value
      ).format("MM")}-01`
    );
  };

  const mensualData = {
    labels: dashboardSelectData.labels,
    datasets: dashboardSelectData.datasets,
  };

  const mensualDataC = {
    labels: dashboardSelectDataContrataciones.labels,
    datasets: dashboardSelectDataContrataciones.datasets,
  };

  const filters = [
    { id: "filter_puesto", desc: "Código de puesto" },
    { id: "filter_nombre_puesto", desc: "Nombre del puesto" },
    { id: "filter_anio", desc: "Año" },
  ];

  const filtrado = (e) => {
    e.preventDefault();
    if (tipoBusqueda.id === "filter_puesto") {
      dispatch(getDashboardSelecResp({ filter_puesto: e.target.filter.value }));
    }
    if (tipoBusqueda.id === "filter_nombre_puesto") {
      dispatch(
        getDashboardSelecResp({ filter_nombre_puesto: e.target.filter.value })
      );
    } else {
      dispatch(getDashboardSelecResp({ filter_anio: e.target.filter.value }));
    }
  };

  const _getDaashboard = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getDashboardSelecResp({
        offset: offs,
        limit: lim,
        tipo_busqueda: tipoBusqueda.id,
        filter:
          tipoBusqueda.id === "filter_anio"
            ? filt !== ""
              ? !isNaN(filt)
                ? filt
                : `${filt.charAt(6)}${filt.charAt(7)}${filt.charAt(
                    8
                  )}${filt.charAt(9)}-${filt.charAt(3)}${filt.charAt(
                    4
                  )}-${filt.charAt(0)}${filt.charAt(1)}`
              : filt
            : filt,
      })
    );

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        {/*  {userRoles &&
          userRoles.find(
            (u) =>
              u.replace("Responsable_", "") === props.match.params.tipoWorkflow ||
              u === "jefe"
          ) === undefined ? (
          <Alert variant="danger" className="mt-4 mb-1 mx-3">
            Su perfil no puede visualizar los {props.match.params.tipoWorkflow}!
          </Alert>
        ) : (*/}
        <Container fluid>
          {/*card vacantes disponibles */}
          <Col md={12}>
            <Card className="border-0">
              <Card.Body>
                <Row>
                  <Col md="4" className="mb-2 mb-sm-0">
                    <Card className="d-flex flex-wrap justify-content-between align-items-between">
                      <Card.Body
                        className="dashboard-card oActivos shadow rounded d-flex flex-wrap justify-content-between align-items-between"
                        style={{ border: "1px solid #ced4da" }}
                      >
                        {loaderDashboard ? (
                          <div className="d-flex justify-content-center w-100">
                            <Spinner
                              animation="border"
                              role="status"
                              className="d-flex justify-content-center"
                            />
                          </div>
                        ) : (
                          <>
                            <Col className="m-0">
                              <Col
                                sm="12"
                                md="12"
                                lg="12"
                                xl="12"
                                className="d-flex flex-wrap justify-content-center align-items-center pb-1 pt-1 mb-1"
                              >
                                <p className="title2">
                                  <span className="font-weight-bold title2">
                                    {props.match.params.tipoWorkflow} Vacantes
                                  </span>
                                </p>
                              </Col>

                              <Col sm="12" md="12" lg="12" xl="12">
                                <Row className="pl-3 d-flex flex-wrap justify-content-between align-items-between">
                                  <h1 className="font-weight-bold title2 m-auto">
                                    {dashboardSelectDataVacantes.Vacantes
                                      ? dashboardSelectDataVacantes.Vacantes
                                      : 0}
                                  </h1>
                                </Row>
                              </Col>

                              <Col
                                sm="12"
                                md="12"
                                lg="12"
                                xl="12"
                                className="d-flex flex-wrap justify-content-center align-items-center"
                              >
                                <p className="footer2">
                                  <span className="font-weight-bold footer2">
                                    {dashboardSelectDataVacantes.porcentaje
                                      ? dashboardSelectDataVacantes.porcentaje
                                      : 0}
                                    % vs año anterior
                                  </span>
                                </p>
                              </Col>
                              {/* </>
                          )} */}
                            </Col>
                            <Col
                              md="2"
                              className="d-flex flex-wrap justify-content-center align-items-center pl-0"
                            >
                              <img
                                src={onBoardingPic}
                                alt="Imagen OffBoarding"
                                className="m-auto"
                                style={{
                                  marginRight: "1rem",
                                  display: "inline-block",
                                  width: "80px",
                                }}
                              ></img>
                            </Col>
                          </>
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md="8" className="mb-2 mb-sm-0">
                    <Card className="d-flex flex-wrap justify-content-between align-items-between">
                      <Card.Body
                        className="dashboard-card oActuales shadow rounded d-flex flex-wrap justify-content-between align-items-between"
                        style={{ border: "1px solid #ced4da" }}
                      >
                        {loaderDashboard ? (
                          <div className="d-flex justify-content-center w-100">
                            <Spinner
                              animation="border"
                              role="status"
                              className="d-flex justify-content-center"
                            />
                          </div>
                        ) : (
                          <>
                            <Col>
                              <Row>
                                <Col
                                  sm="12"
                                  md="12"
                                  lg="12"
                                  xl="12"
                                  className="d-flex flex-wrap justify-content-center align-items-center pb-1 pt-1 mb-1"
                                  // style={{ borderBottom: "1px solid #ced4da" }}
                                >
                                  <p className="m-0">
                                    <span className="font-weight-bold">
                                      Cumplimiento de actividades
                                    </span>
                                  </p>
                                </Col>
                                <Col>
                                  <Col sm="12" md="12" lg="12" xl="12">
                                    <Row className="pl-3 d-flex flex-wrap justify-content-center align-items-center">
                                      <h1 className="font-weight-bold title2 m-auto">
                                        {dashboardSelectDataVacantes.Total
                                          ? dashboardSelectDataVacantes.Total
                                          : 0}
                                      </h1>
                                    </Row>
                                  </Col>

                                  <p className="footer2 mt-0 d-flex flex-wrap justify-content-center align-items-center">
                                    <span className="font-weight-bold footer2">
                                      Total
                                    </span>
                                  </p>
                                  {/* </>
                          )} */}
                                </Col>
                                <Col>
                                  <Col sm="12" md="12" lg="12" xl="12">
                                    <Row className="pl-3 d-flex flex-wrap justify-content-center align-items-center">
                                      <h1 className="font-weight-bold title2 m-auto">
                                        {dashboardSelectDataVacantes.En_proceso
                                          ? dashboardSelectDataVacantes.En_proceso
                                          : 0}
                                      </h1>
                                    </Row>
                                  </Col>

                                  <p className="footer2 mt-0 d-flex flex-wrap justify-content-center align-items-center">
                                    <span className="font-weight-bold footer2">
                                      En Proceso
                                    </span>
                                  </p>
                                  {/* </>
                          )} */}
                                </Col>
                                <Col>
                                  <Col sm="12" md="12" lg="12" xl="12">
                                    <Row className="pl-3 d-flex flex-wrap justify-content-center align-items-center">
                                      <h1 className="font-weight-bold title2 m-auto">
                                        {dashboardSelectDataVacantes.Abierto
                                          ? dashboardSelectDataVacantes.Abierto
                                          : 0}
                                      </h1>
                                    </Row>
                                  </Col>

                                  <p className="footer2 mt-0 d-flex flex-wrap justify-content-center align-items-center">
                                    <span className="font-weight-bold footer2">
                                      Abiertas
                                    </span>
                                  </p>
                                  {/* </>
                          )} */}
                                </Col>
                                <Col>
                                  <Col sm="12" md="12" lg="12" xl="12">
                                    <Row className="pl-3 d-flex flex-wrap justify-content-center align-items-center">
                                      <h1 className="font-weight-bold title2 m-auto">
                                        {dashboardSelectDataVacantes.Cerrado
                                          ? dashboardSelectDataVacantes.Cerrado
                                          : 0}
                                      </h1>
                                    </Row>
                                  </Col>

                                  <p className="footer2 mt-0 d-flex flex-wrap justify-content-center align-items-center">
                                    <span className="font-weight-bold footer2">
                                      Cerradas
                                    </span>
                                  </p>
                                  {/* </>
                          )} */}
                                </Col>
                              </Row>
                            </Col>
                            <Col
                              md="2"
                              className="mt-0 d-flex flex-wrap justify-content-center align-items-center"
                            >
                              <img
                                src={onBoardingteachingPic}
                                alt="Imagen OffBoarding"
                                className="m-auto"
                                style={{
                                  marginRight: "1rem",
                                  display: "inline-block",
                                  width: "80px",
                                }}
                              ></img>
                            </Col>
                          </>
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>

          {/*filtros html */}
          <Col md={12}>
            <Card className="border-0">
              <Card.Body>
                <Row>
                  <Col md={8} className="mb-0 mb-sm-0">
                    <Row>
                      <Col md="12" className="mb-2 mb-sm-0">
                        <Form onSubmit={filtrado}>
                          <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
                            <Col>
                              <h6>
                                <b>Búsqueda por: {tipoBusqueda.desc}</b>
                              </h6>
                            </Col>
                            <Col xs="auto">
                              <Form.Control
                                name="filter"
                                type="search"
                                id="filtro"
                                placeholder="Buscar"
                                className="rounded-pill form-control-sm"
                              ></Form.Control>
                            </Col>
                            <Col xs="auto">
                              <ButtonGroup>
                                <Button
                                  variant="light"
                                  size="sm"
                                  className="rounded-pill mr-1"
                                  onClick={() => seeAll()}
                                >
                                  <i className="material-icons">list</i>
                                </Button>

                                <OverlayTrigger
                                  placement="auto"
                                  overlay={
                                    <Tooltip {...props}>
                                      Seleccionar Filtrado
                                    </Tooltip>
                                  }
                                >
                                  <Dropdown className="ml-3 mr-3">
                                    <Dropdown.Toggle
                                      variant="light"
                                      className="btn-sm font rounded-pill"
                                    >
                                      <i className="material-icons">
                                        filter_list
                                      </i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      {filters.map((item) => (
                                        <Dropdown.Item
                                          onClick={() => setTipoBusqueda(item)}
                                          key={item.id}
                                        >
                                          {item.desc}
                                        </Dropdown.Item>
                                      ))}
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </OverlayTrigger>
                              </ButtonGroup>
                            </Col>
                          </Form.Row>
                        </Form>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>

          {/*graficos*/}
          <Col md={12}>
            <Card className="border-0">
              <Card.Body>
                <Row>
                  {/*grafico de barra*/}
                  <Col md="8" className="mb-0 mb-sm-0">
                    <Row>
                      <Col md="12" className="mb-2 mb-sm-0">
                        <Card
                          className="shadow"
                          style={{ border: "1px solid #ced4da" }}
                        >
                          <Card.Body>
                            <h5 className="text-muted">Contrataciones</h5>
                            {loaderDashboard ? (
                              <div className="d-flex justify-content-center w-100">
                                <Spinner
                                  animation="border"
                                  role="status"
                                  className="d-flex justify-content-center"
                                />
                              </div>
                            ) : (
                              <Bar
                                height={155}
                                data={mensualData}
                                options={{
                                  fill: false,
                                  interaction: {
                                    intersect: false,
                                  },
                                  responsive: true,
                                  legend: {
                                    display: false,
                                  },
                                  // scales:{
                                  //   x:{ stacked: true},
                                  //   y:{ stacked: true}
                                  // },
                                  radius: 0,
                                }}
                              />
                            )}
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                  </Col>

                  {/*grafico pie(circulo)*/}
                  <Col md="4" className="mb-0 mb-sm-0">
                    <Row>
                      <Col md="12" className="mb-2 mb-sm-0">
                        <Card
                          className="shadow"
                          style={{ border: "1px solid #ced4da" }}
                        >
                          <Card.Body>
                            <h5 className="text-muted">Motivo Solicitud</h5>
                            {loaderDashboardContrataciones ? (
                              <div className="d-flex justify-content-center w-100">
                                <Spinner
                                  animation="border"
                                  role="status"
                                  className="d-flex justify-content-center"
                                />
                              </div>
                            ) : (
                              <Pie
                                height={155}
                                data={mensualDataC}
                                options={{
                                  fill: false,
                                  interaction: {
                                    intersect: false,
                                  },
                                  responsive: true,
                                  legend: {
                                    display: false,
                                  },
                                  //scales: {
                                  //  x: { stacked: true },
                                  //  y: { stacked: true }
                                  // },
                                  radius: 60,
                                }}
                              />
                            )}
                          </Card.Body>
                          <br></br>
                          <br></br>
                        </Card>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Container>
        {/*)} acordarme de cerrar bien esto mas tarde*/}
      </div>
    </>
  );
};

export default DashboardSeleccionContratacion;
